/**
 * Canonical hour used when the UI is "whole day" only (one slot per calendar day).
 * @see useWeeklyPlan slot keys YYYY-MM-DD-{hour}
 */
export const FULL_DAY_CANONICAL_HOUR = 12;

/**
 * Four daily plan buckets (Europe/Zurich wall-clock hour).
 * canonicalHour is stored in localStorage slot keys (see useWeeklyPlan).
 * Used to aggregate existing items in full-day UI.
 */
export const PLAN_TIME_BUCKETS = [
  { label: "Vormittag", startHour: 6, endHour: 11, canonicalHour: 9 },
  { label: "Mittag", startHour: 11, endHour: 14, canonicalHour: 12 },
  { label: "Nachmittag", startHour: 14, endHour: 18, canonicalHour: 15 },
  { label: "Abend", startHour: 18, endHour: 22, canonicalHour: 18 },
];

/**
 * Map 0–23 hour to the canonical slot hour (9, 12, 15, or 18).
 */
export function wallHourToCanonicalHour(hour) {
  if (typeof hour !== "number" || Number.isNaN(hour)) return PLAN_TIME_BUCKETS[0].canonicalHour;
  if (hour < 6) return PLAN_TIME_BUCKETS[0].canonicalHour;
  if (hour >= 22) return PLAN_TIME_BUCKETS[PLAN_TIME_BUCKETS.length - 1].canonicalHour;
  for (const b of PLAN_TIME_BUCKETS) {
    if (hour >= b.startHour && hour < b.endHour) return b.canonicalHour;
  }
  return PLAN_TIME_BUCKETS[PLAN_TIME_BUCKETS.length - 1].canonicalHour;
}
